import ClaimReasonInput from './ClaimReasonInput'
export default ClaimReasonInput
